import api from '@services/api';
import { PaginationResponse } from '../models/pagination';
import { ProjectSearchInput, ProjectUpdateRequest } from '../models/project';
import { ByCodeResponse, ProjectResponse } from '../models/projects';

/**
 * <p>
 * API endpoints that cover all project related CRUD calls
 */
export const projectsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    projects: builder.query<PaginationResponse<ProjectResponse>, ProjectSearchInput>({
      query: (params: ProjectSearchInput) => ({
        url: encodeURI(
          `/report/project/search?bringClose=${params.bringClosed}${
            params.searchTerm ? `&searchTerm=${params.searchTerm}` : ''
          }&projectSubType=${params.projectSubType}${
            params.projectCode ? `&projectCode=${params.projectCode}` : ''
          }&branch=${params.branch}&page=${params.page}&size=${params.size}&sortKey=name&sortDirection=ASC`,
        ),
      }),
      providesTags: ['Projects'],
    }),
    updateProjects: builder.mutation<void, ProjectUpdateRequest>({
      query: (project) => ({
        url: encodeURI(`/report/project/update`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['Projects'],
    }),
    byCode: builder.query<ByCodeResponse, string>({
      query: (params: string) => ({
        url: encodeURI(`/report/project/byCode?code=${params}`),
      }),
      providesTags: ['Projects'],
    }),
  }),
});

export const { useProjectsQuery, useUpdateProjectsMutation, useByCodeQuery } = projectsApi;
